import type { Reducer } from 'redux';

import type { LoadSharePointVideoStreamUrlSetAction } from '../../domains/sharePointVideoStreamUrlSet/actions.types';
import { moveToFulfilled, moveToPending, moveToRejected } from '../types';

import type { SharePointVideoStreamUrlSets } from './types';

export type SharePointVideoStreamUrlSetAction = LoadSharePointVideoStreamUrlSetAction;

const initialState: SharePointVideoStreamUrlSets = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<SharePointVideoStreamUrlSets, SharePointVideoStreamUrlSetAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'SHAREPOINT_VIDEO_STREAM_URL_SET.LOAD_PENDING':
      return moveToPending(state, [action.payload.id]);
    case 'SHAREPOINT_VIDEO_STREAM_URL_SET.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.id], action.payload.error);
    case 'SHAREPOINT_VIDEO_STREAM_URL_SET.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.sharePointVideoStreamUrlSet);
    default:
      return state;
  }
};

export default reducer;
